import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const FileContainer = styled.a`
  width: 180px;
  padding: 7px 11px;
  text-decoration: none;
  font-family: OpenSans, sans-serif;
  font-size: 12px;
  color: #828282;
  overflow: hidden;
  border: 1px solid #BFCFF2;
  border-radius: 10px;
  display: flex!important;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 10px;
  cursor: pointer;
  background-color: #ffffff;
  &.no-width{
    width: auto;
  }
  &:hover{
    text-decoration: none;
    color: #828282;
  }
`

export const FileIcon = styled.div`
  margin-right: 7px;
  & img{
    max-width: none!important;
  }
`

export const FileName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ShowAll = styled.div`
  color: #1C62EF;
  text-decoration: underline;
  cursor: pointer;
`